<template>
  <div class="modal-background" @click="bgtrigger == true ? $emit('close') : ''">
    <div
      :class="['modal', 'position-' + position]"
      :style="{ width: width + 'px', overflow: overflow }"
      @click.stop
    >
      <slot></slot>
      <span class="close printhide" :style="{ color: close }" @click="$emit('close')">
        <slot name="close"><awesomeIcon icon="times" /></slot>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalWindow',
  emits: ['close'],
  props: {
    width: {
      type: String,
      default: '300',
    },
    position: {
      type: String,
      default: 'center',
    },
    bgtrigger: {
      type: Boolean,
      default: true,
    },
    close: {
      type: String,
      default: 'white',
    },
    overflow: {
      type: String,
      default: 'visible',
    },
  },
  mounted() {
    if (this.position === 'full') {
      document.getElementById('mainview').classList.add('no-scroll');
    }
  },
  unmounted() {
    document.getElementById('mainview').classList.remove('no-scroll');
  },
};
</script>

<style lang="scss">
// custom plan fix
.position-center .viewport {
  overflow: auto;
  padding: 20px;
  height: 700px;
}
.position-edge .viewport {
  position: absolute;
  @media screen {
    top: 36px;
  }
  bottom: 57px;
  left: 0;
  right: 0;
  overflow: auto;
}

.modal {
  min-width: 100px;
  max-width: 95%;
  min-height: 100px;
  max-height: 100%;
  border-radius: $br;
  @media screen {
    background-color: #efecf3;
  }
  position: fixed;
  &.position-center {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .viewport {
      overflow: auto;
      padding: 20px;
      height: 700px;
    }
    .footer {
      overflow: auto;
    }
  }
  &.position-edge {
    left: 50%;
    transform: translateX(-50%);
    top: 1%;
    bottom: 1%;
    .viewport {
      position: absolute;
      top: 36px;
      bottom: 57px;
      left: 0px;
      right: 0px;
      overflow: auto;
    }
  }
  &.position-full {
    max-width: initial;
    width: initial !important;
    border-radius: 0;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    .titlebar {
      display: none;
    }
    .close {
      color: black !important;
      padding-right: 30px;
    }
    @media #{$desktop} {
      .modalfooter {
        margin-right: 20px;
      }
    }
    @media #{$mobile} {
      .modalfooter {
        background-color: #fff;
      }
    }
    .viewport {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      overflow: auto;
      @media #{$desktop} {
        .card {
          width: 700px;
          height: 1140px;
          margin: 20px auto;
          border-radius: 0;
        }
      }
    }
  }
  .titlebar {
    padding: 10px 20px;
    color: #fff;
    background-color: $color-background;
    border-radius: $br $br 0 0;
    min-height: 16px;
  }
  form {
    input, select, textarea, .inputbox {
      margin-top: 10px;
      &:first-child {
        margin-top: 0;
      }
    }
    .inputbox {
      input {
        background-color: #fff;
      }
    }
  }
  .modalfooter {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: transparent;
    padding: 10px;
    button, .button {
      display: initial;
      width: initial;
      margin-top: 0;
      float: right;
      margin-left: 10px;
    }
  }
  .inset {
    padding: 20px;
    button {
      display: block;
      width: 100%;
      margin-top: 10px;
      &.second {
        color: rgba(#000, 0.8);
        background-color: $color-grey-dark;
        &:hover {
          background-color: darken($color-grey-dark, 5%);
        }
      }
    }
  }
  .close {
    cursor: pointer;
    top: 0px;
    right: 0px;
    position: absolute;
    height: 37px;
    padding-right: 20px;
    line-height: 37px;
    text-align: center;
  }
}
.modal-background {
  position: fixed;
  background: #0006;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
}
</style>
